import React, { useState, useEffect } from 'react';

const API_URL = 'http://185.164.73.170:5000';

export default function Mugramdata() {
    const [posts, setPosts] = useState([]);
    const [newPost, setNewPost] = useState({ text: '', mediaCount: 0 });
    const [editingPost, setEditingPost] = useState(null);

    useEffect(() => {
        fetch(`${API_URL}/posts`)
            .then((res) => res.json())
            .then((data) => {
                const postsWithMediaCount = data.map((post) => {
                    const mediaCount = post.media ? post.media.length : 0;
                    return { ...post, mediaCount };
                });
                setPosts(postsWithMediaCount);
            });
    }, []);

    const handleDelete = (id) => {
        fetch(`${API_URL}/posts/${id}`, { method: 'DELETE' })
            .then(() => setPosts(posts.filter((p) => p.id !== id)));
    };

    const handleEdit = (id, text, mediaCount) => {
        fetch(`${API_URL}/posts/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ text, mediaCount }),
        })
            .then((res) => res.json())
            .then((updatedPost) => {
                setPosts(posts.map((p) => (p.id === id ? updatedPost : p)));
                setEditingPost(null);
            });
    };

    const handleCreate = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('text', newPost.text);
        if (newPost.mediaCount) formData.append('mediaCount', newPost.mediaCount);

        fetch(`${API_URL}/posts`, {
            method: 'POST',
            body: formData,
        })
            .then((res) => res.json())
            .then((newPostData) => {
                const mediaCount = newPost.mediaCount || 0;
                const newPostWithMediaCount = {
                    ...newPostData,
                    mediaCount,
                };
                setPosts([...posts, newPostWithMediaCount]);
                setNewPost({ text: '', mediaCount: 0 });
            });
    };

    return (
        <div>
            <form onSubmit={handleCreate}>
                <textarea
                    placeholder="Write your post..."
                    value={newPost.text}
                    onChange={(e) => setNewPost({ ...newPost, text: e.target.value })}
                    required
                />
                <input
                    type="number"
                    placeholder="Enter number of images"
                    value={newPost.mediaCount}
                    onChange={(e) => setNewPost({ ...newPost, mediaCount: parseInt(e.target.value) })}
                />
                <button type="submit">Create Post</button>
            </form>

            <div className="postsadmin">
                {posts.map((post) => (
                    <div className="post" key={post.id}>
                        <p>{post.text}</p>
                        <p style={{userSelect: 'all'}}>{post.id}</p>
                        <p>Number of images to be uploaded: {post.mediaCount}</p>

                        <button onClick={() => handleDelete(post.id)}>Delete</button>
                        <button
                            onClick={() => {
                                const newText = prompt('Edit post text:', post.text);
                                const newMediaCount = prompt('Edit number of images:', post.mediaCount);
                                if (newText && newMediaCount) {
                                    handleEdit(post.id, newText, parseInt(newMediaCount));
                                }
                            }}
                        >
                            Edit
                        </button>
                    </div>
                ))}
            </div>


            {editingPost && (
                <div className="edit-post">
                    <h2>Edit Post</h2>
                    <textarea
                        value={editingPost.text}
                        onChange={(e) => setEditingPost({ ...editingPost, text: e.target.value })}
                    />
                    <input
                        type="number"
                        value={editingPost.mediaCount}
                        onChange={(e) => setEditingPost({ ...editingPost, mediaCount: parseInt(e.target.value) })}
                    />
                    <button
                        onClick={() => {
                            handleEdit(editingPost.id, editingPost.text, editingPost.mediaCount);
                        }}
                    >
                        Save Changes
                    </button>
                    <button onClick={() => setEditingPost(null)}>Cancel</button>
                </div>
            )}
        </div>
    );
}
